import request from "@utils/request";
let urlStr = ""
// 获取公司部门信息
export function getDepartmentAPI() {
    return request.get(urlStr + '/department_list', {}, { login: false })
}
// 获取分类页数据信息
export function classifyApi(type) {
    return request.get(urlStr + '/category_list/' + type, {}, { login: false })
}
// 获取商品数据
export function getShopApi(query) {
    return request.get(urlStr + '/cate_pro_list', query, { login: false })
}
// 获取联动位置信息
export function getLinkageApi() {
    return request.get(urlStr + '/property/address_list', {}, { login: false })
}
// 提交报修
export function submitRepairsApi(data) {
    return request.post(urlStr + '/property/create_repair', data, { login: true })
}
// 提交简历
export function submitPdfApi(data) {
    return request.post(urlStr + '/user/create_job', data, { login: true })
}
//  抢单列表 派单列表
export function getRobApi(query) {
    return request.get(urlStr + '/property/repair_list', query, { login: false })
}
//  抢单列表 派单列表
export function getMyRobApi(query) {
    return request.get(urlStr + '/property/my_dispatch_list', query, { login: false })
}
//派单 获取物业人员列表

export function getRobPeopleList(query) {
    return request.get(urlStr + '/user/department_user_list', query, { login: false })
}
//派单 获取保洁人员列表

export function getRobCleanKeepingPeopleList(query) {
    return request.get(urlStr + '/user/cleaning_user_list', query, { login: false })
}
// 派单 确定指派人员
export function RobAssignStaff(data) {
    return request.post(urlStr + '/property/appoint_repair_order', data, { login: true })
}
// 点击抢单 已经作废
export function RobApi(data) {
    return request.post(urlStr + '/property/rob_repair_order', data, { login: true })
}
// 判断用户是否是物业人员
export function getStaffApi() {
    return request.get(urlStr + '/property/is_property_user', {}, { login: true })
}
// 我的维修列表
export function getMaintainApi(query) {
    return request.get(urlStr + '/property/my_repair_list', query, { login: true })
}
// 提交订单进度
export function scheduleApi(data) {
    return request.post(urlStr + '/property/submit_repair_rate', data, { login: true })
}
// 评论
export function commentApi(data) {
    return request.post(urlStr + '/property/comment', data, { login: true })
}
// 我的报修列表
export function getRepairsListApi(query) {
    return request.get(urlStr + '/property/my_request_repair_list', query, { login: true })
}
// 我的评论列表
export function getDiscussApi(query) {
    return request.get(urlStr + '/property/my_comment_repair_list', query, { login: true })
}
// 我的班车列表
export function getBancheOrderApi(query) {
    return request.get(urlStr + '/user/banche_order_list', query, { login: true })
}
// 删除我的报修记录
export function delRepairsApi(data) {
    return request.post(urlStr + '/property/delete_repair', data, { login: true })
}
// 我的维修结果评价
export function repairCommentListApi(query) {
    return request.get(urlStr + '/property/my_repair_comment_list', query, { login: true })
}
// 我的维修 接单
export function repairTakeOrderApi(data) {
    return request.post(urlStr + '/property/confirm_repair', data, { login: true })
}
// 出勤状态
export function outstatusApi() {
    return request.get(urlStr + '/property/get_user_outstatus', {}, { login: true })
}
// 员工列表
export function staffListApi() {
    return request.get(urlStr + '/user/department_user_list', {}, { login: true })
}
// 判断用户是否有经理卡权限
export function isManagerApi() {
    return request.get(urlStr + '/user/is_manage_user', {}, { login: true })
}
// 提交员工卡分配
export function allocationApi(data) {
    return request.post(urlStr + '/user/user_car_create', data, { login: true })
}
// 员工卡列表
export function allocationListApi(query) {
    return request.get(urlStr + '/user/user_car_list', query, { login: true })
}
// 回收员工卡
export function recycleApi(data) {
    return request.post(urlStr + '/user/recycle_card', data, { login: true })
}
// 咖啡支付页面
export function coffeePay(data) {
    return request.post(urlStr + '/order/coffee_pay', data, { login: true })
}
// 线下京东支付页面
export function jdPay(data) {
    return request.post(urlStr + '/order/offline_jingdong_pay', data, { login: true })
}
// 线下商品支付页面
export function offlinePay(data) {
    return request.post(urlStr + '/order/offline_pro_pay', data, { login: true })
}
// 食堂支付页面
export function diningroomApi() {
    return request.get(urlStr + '/order/get_diningroom_info', {}, { login: true })
}
// 支付
export function payApi(data) {
    return request.post(urlStr + '/order/jingli_pay', data, { login: true })
}
// 直接支付
export function directPayApi() {
    return request.get(urlStr + '/order/direct_pay', {}, { login: true })
}
// 班车数据
export function buspaymentApi() {
    return request.get(urlStr + '/order/get_bus_pay_info', {}, { login: true })
}
// 班车支付
export function buspayApi() {
    return request.get(urlStr + '/order/direct_bus_pay', {}, { login: true })
}
// 班车支付
export function buspaysmallApi() {
    return request.get(urlStr + '/order/direct_bus_pay_small', {}, { login: true })
}
// 自动售卖机数据
export function autopaymentApi() {
    return request.get(urlStr + '/auto_userinfo', {}, { login: true })
}

// 获取用户部门信息
export function departmentApi() {
    return request.get(urlStr + '/user/department', {}, { login: true })
}
// 获取支付码
export function payYardApi() {
    return request.get(urlStr + '/user/getUserYueQrcode', {}, { login: true })
}
// 查询是否支付
export function queryPayApi() {
    return request.get(urlStr + '/user/pay', {}, { login: true })
}
//是否拥有公卡码
export function isPubliCard() {
    return request.get(urlStr + '/user/is_have_gongka', {}, { login: true })
}
// 获取支付码
export function publiCard() {
    return request.get(urlStr + '/user/getUserGongKaQrcode', {}, { login: true })
}
// 我的工卡
export function myCardApi(query) {
    return request.get(urlStr + '/user/my_card_list', query, { login: true })
}
// 我的班车券列表
export function regularBusApi() {
    return request.get(urlStr + '/user/my_bus_card_list', {}, { login: true })
}
// 使用记录
export function usageRecordApi(query) {
    return request.get(urlStr + '/user/bus_card_log_list', query, { login: true })
}